var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpCabinetSliderArrowL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 60,
    viewBox: "0 0 40 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 39,
    height: 59,
    rx: 19.5,
    transform: "matrix(-1 0 0 1 39 0)",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 40C24.7969 39.9999 25.0868 39.916 25.3335 39.7589C25.5801 39.6018 25.7723 39.3785 25.8858 39.1173C25.9993 38.8561 26.029 38.5686 25.9712 38.2913C25.9133 38.014 25.7705 37.7593 25.5608 37.5593L17.6209 29.9912L25.5608 22.4231C25.834 22.1535 25.9852 21.7923 25.9818 21.4174C25.9784 21.0425 25.8206 20.6839 25.5425 20.4188C25.2644 20.1537 24.8882 20.0033 24.4948 20.0001C24.1015 19.9968 23.7226 20.1409 23.4397 20.4014L14.4392 28.9803C14.158 29.2485 14 29.6121 14 29.9912C14 30.3704 14.158 30.734 14.4392 31.0021L23.4397 39.5811C23.7209 39.8492 24.1024 39.9999 24.5002 40Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCabinetSliderArrowL);
export default __webpack_public_path__ + "static/media/lp_cabinet_slider_arrow_l.fa69f87866806fad763f29e9d9578718.svg";
export { ForwardRef as ReactComponent };